import React, { useContext, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../../constants/colors';
import { biggerThanOrEqualTo } from '../../../core/util/styledComponents';
import AuthenticationContext from '../../../core/login/AuthenticationContext';
import { requiresBottomSafeArea, useUserAgent } from '../../../core/util/device';

const Root = styled(({ needsSafeArea, isLoggedIn, ...rest }) => <div {...rest} />).withConfig({ componentId: 'sc-lka23o-0' })`
  width: 100%;
  position: fixed;
  left: 0;
  bottom: ${(props) => (props.isLoggedIn ? 56 : 0)}px;
  height: fit-content;
  background: ${colors.theWhiteAlbum};
  z-index: 2;
  border-top: 1px solid ${colors.dorianGrey};
  padding: 15px 0;
  ${(props) =>
    props.needsSafeArea && // for iOS native
    css`
      padding-bottom: 24px;
    `};

  ${biggerThanOrEqualTo.sm`
    bottom: 0;
  `}
`;

const ChildContainer = styled.div.withConfig({ componentId: 'sc-lka23o-1' })`
  width: 90%;
  margin: 0 auto;
`;

export type StickyFooterProps = {
  children: any;
  className?: string;
};

const StickyFooter = ({ children, className }: StickyFooterProps) => {
  const { isLoggedIn } = useContext(AuthenticationContext);
  const userAgent = useUserAgent();

  return (
    <Root
      className={className}
      isLoggedIn={isLoggedIn}
      needsSafeArea={useMemo(() => requiresBottomSafeArea(userAgent), [userAgent])}
    >
      <ChildContainer>{children}</ChildContainer>
    </Root>
  );
};

export default StickyFooter;
